// A row error returned by the API for a batch upload
export interface BulkUploadRowError {
  row: number;
  id?: string;
  field: string;
  message: string;
}

function isRowError(error: unknown): error is BulkUploadRowError {
  return typeof error === 'object' && error !== null && 'row' in error && 'message' in error;
}

// Readable batch upload errors, one per line (e.g. `Row 2 (Client -> AccountId): No AccountId found for Transaction field Client (Unknown)`).
// Entries without a row (e.g. errors raised before rows are processed) are shown as they came.
export function formatBulkUploadErrors(errors: unknown[]): string {
  return errors
    .map((e) => {
      if (!isRowError(e)) {
        return typeof e === 'string' ? e : JSON.stringify(e);
      }
      return e.field ? `Row ${e.row} (${e.field}): ${e.message}` : `Row ${e.row}: ${e.message}`;
    })
    .join('\n');
}
